import { getOidRange, } from '@verdant-web/common';
import { IDBService } from '../IDBService.js';
export class BaselinesStore extends IDBService {
    constructor(db) {
        super(db);
        this.getAllForDocument = async (oid, { mode = 'readonly', transaction, } = {}) => {
            const baselines = [];
            await this.iterateOverAllForDocument(oid, (baseline) => {
                baselines.push(baseline);
            }, { mode, transaction });
            return baselines;
        };
        this.iterateOverAllForDocument = async (oid, iterator, { mode = 'readonly', transaction, } = {}) => {
            return this.iterate('baselines', (store) => {
                const [start, end] = getOidRange(oid);
                return store.openCursor(IDBKeyRange.bound(start, end, false, false));
            }, iterator, mode, transaction);
        };
        this.getAllForMultipleDocuments = async (docOids, { mode = 'readonly' } = {}) => {
            const result = await this.runAll('baselines', (store) => {
                return docOids.map((oid) => {
                    const [start, end] = getOidRange(oid);
                    return store.getAll(IDBKeyRange.bound(start, end, false, false));
                });
            }, mode);
            return result.flat();
        };
        this.getAllSince = async (timestamp, { mode = 'readonly' } = {}) => {
            return this.run('baselines', (store) => {
                const range = timestamp
                    ? IDBKeyRange.lowerBound(timestamp, true)
                    : undefined;
                const index = store.index('timestamp');
                return index.getAll(range);
            }, mode);
        };
        this.get = async (oid, { transaction, mode = 'readonly', } = {}) => {
            return this.run('baselines', (store) => store.get(oid), mode, transaction);
        };
        this.set = async (baseline, { transaction } = {}) => {
            await this.run('baselines', (store) => store.put(baseline), 'readwrite', transaction);
        };
        this.setAll = async (baselines, { transaction } = {}) => {
            await this.runAll('baselines', (store) => {
                return baselines.map((baseline) => store.put(baseline));
            }, 'readwrite', transaction);
        };
        this.reset = () => {
            return this.clear('baselines');
        };
        this.delete = async (oid, { transaction }) => {
            await this.run('baselines', (store) => store.delete(oid), 'readwrite', transaction);
        };
    }
}
//# sourceMappingURL=BaselinesStore.js.map